import {
    InvestmentDataColumnConfiguration,
    InvestmentDataSectionType,
    ViewColumnType,
} from '@wdx/shared/swagger-gen';

export const TRANSACTION_DEFAULT_PRIMARY_COLUMNS: (
    transactionDateField: string,
) => InvestmentDataColumnConfiguration[] = (transactionDateField: string) => [
    {
        name: 'COLUMN_PORTFOLIO_TRANSACTION_DATE',
        path: transactionDateField,
        fieldType: ViewColumnType.Date,
    },
    {
        name: 'COLUMN_PORTFOLIO_TRANSACTION_TO',
        path: 'to',
        fieldType: ViewColumnType.Text,
    },
    {
        name: 'COLUMN_PORTFOLIO_TRANSACTION_TYPE',
        path: 'transactionType.description',
        fieldType: ViewColumnType.Text,
    },
    {
        name: 'COLUMN_PORTFOLIO_TRANSACTION_STATUS',
        path: 'status',
        fieldType: ViewColumnType.Status,
    },
    {
        name: 'COLUMN_PORTFOLIO_TRANSACTION_AMOUNT',
        path: 'amount',
        fieldType: ViewColumnType.Text,
    },
];

export const TRANSACTION_DETAIL_DEFAULT_FIELDS: InvestmentDataColumnConfiguration[] =
    [
        {
            path: 'uniqueId',
            name: 'COLUMN_PORTFOLIO_TRANSACTION_UNIQUE_ID',
            fieldType: ViewColumnType.Text,
            sectionType: InvestmentDataSectionType.Primary,
            sectionCode: null,
            isCopyable: false,
            isSortable: false,
            isSearchable: false,
        },
        {
            path: 'from',
            name: 'COLUMN_PORTFOLIO_TRANSACTION_FROM',
            fieldType: ViewColumnType.Text,
            sectionType: InvestmentDataSectionType.Primary,
            sectionCode: null,
            isCopyable: false,
            isSortable: false,
            isSearchable: false,
        },
        {
            path: 'description',
            name: 'COLUMN_PORTFOLIO_TRANSACTION_DESCRIPTION',
            fieldType: ViewColumnType.Text,
            sectionType: InvestmentDataSectionType.Primary,
            sectionCode: null,
            isCopyable: false,
            isSortable: false,
            isSearchable: false,
        },
        {
            path: 'accountId',
            name: 'COLUMN_PORTFOLIO_TRANSACTION_ACCOUNT_ID',
            fieldType: ViewColumnType.Text,
            sectionType: InvestmentDataSectionType.Primary,
            sectionCode: null,
            isCopyable: false,
            isSortable: false,
            isSearchable: false,
        },
    ];
